import { createContext } from 'react';
var ModalRootContext = /*#__PURE__*/createContext({
  updateModalHeight: function updateModalHeight() {
    return undefined;
  }
});
export default ModalRootContext;
//# sourceMappingURL=ModalRootContext.js.map